var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie-player',{staticStyle:{"margin":"0 auto","width":"400px","height":"400px"},attrs:{"src":"/animations/guus.json","background":"transparent","speed":"1","loop":"","autoplay":""}})}
var staticRenderFns = []

export { render, staticRenderFns }